var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeel = function SvgFeel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    fillRule: "evenodd",
    d: "M44 26.7a23 23 0 0 0-10.1-7.6c-7.3-2.8-16.5-2-22 5.4a19.5 19.5 0 0 0-2.4 16.3 48 48 0 0 0 8 16.5c3.8 5.2 8.4 9.8 13 13.2a25 25 0 0 0 13.1 5.8h.8c4.3-.2 9-2.6 13.2-5.8 4.5-3.4 9-8 12.8-13.2a48 48 0 0 0 8-16.5A19.2 19.2 0 0 0 76 24.5c-5.4-7.5-14.6-8.2-21.9-5.4A23 23 0 0 0 44 26.7Zm4.2 5.3c1.7-3 4.7-5.5 8.2-6.9 5.5-2.1 11.2-1.2 14.4 3.2 2 2.8 2.5 6.5 1.4 11-1 4.6-3.6 9.6-7 14.3a56.3 56.3 0 0 1-11.5 11.8c-4 3-7.3 4.4-9.7 4.5-2.4-.1-5.8-1.6-9.7-4.5-4-3-8.1-7.2-11.5-11.8-3.4-4.7-6-9.7-7-14.2-1.1-4.6-.6-8.3 1.4-11.1C20.4 23.9 26 23 31.6 25c3.5 1.4 6.5 3.9 8.2 7l1.6 2.3a3.3 3.3 0 0 0 5.2 0 18 18 0 0 0 1.6-2.4Z",
    clipRule: "evenodd"
  })));
};
export default SvgFeel;